import React from 'react';
import moment from 'moment';
import FontAwesome from 'react-fontawesome';
import * as MaterialUI from 'material-ui';
import { connect } from 'react-redux';
import { Row, Col } from 'reactstrap';

import { EliminarConfirmacionC } from 'modules/general/component';
import * as feriadosActions from 'modules/feriados/action';
import * as generalActions from 'modules/general/action';
import { checkPermissions } from 'core/generalFunctions';

moment.locale('es');

@connect(store => ({
  feriados: store.get('feriados')
}))
export class MainC extends React.Component {
  constructor(props) {
    super(props);
    this.deleteFeriado = this.deleteFeriado.bind(this);
    this.addFeriado = this.addFeriado.bind(this);
  }
  componentDidMount() {
    this.props.dispatch(feriadosActions.get());
    this.props.dispatch(generalActions.dashboard_changeTitle('FERIADOS'));
  }
  desabilitarFechas(date) {
    if (moment(date).startOf('day').toDate().getTime() < moment().startOf('day').toDate().getTime())
      return true;
    else return false;
  }
  submitForm = (val, data) => this.props.dispatch(feriadosActions.set(moment(data).startOf('day').toDate()))

  confirmDelete = () => {
    this.props.dispatch(feriadosActions.delete_(this.props.feriados.getIn(['viajeAEliminar', 'id'])));
    this.props.dispatch(feriadosActions.setState({viajeAEliminar: false}));
  };

  deleteFeriado = feriado => this.props.dispatch(feriadosActions.setState({viajeAEliminar: feriado ? feriado : false}))

  addFeriado = () => this.refs.diaViaje.focus();

  render() {
    let eliminarId = this.props.feriados.getIn(['viajeAEliminar', 'id']);
    return (
      <div>
        <Row className="rowContainer">
          <Col md={{ size: 4, offset: 4 }}>
            <MaterialUI.Paper zDepth={2} className="container">
              <MaterialUI.DatePicker
                name='diaViaje'
                ref="diaViaje"
                className='hidden'
                shouldDisableDate={this.desabilitarFechas}
                onChange={this.submitForm.bind(this)}
              />
              <Row>
                <Col md="12">
                  <MaterialUI.List className="noPadding dividerList">
                    { this.props.feriados.get('lista').map(feriado =>
                      <div key={feriado.get('id')}>
                        <MaterialUI.ListItem
                          disabled
                          rightIconButton={
                            checkPermissions(['admin','administrador_feriados']) &&
                              <MaterialUI.FlatButton
                                icon={<FontAwesome name="trash" />}
                                onTouchTap={()=>this.deleteFeriado(feriado)}
                                className="listIcon red"
                              />
                          }
                          className="textCenter"
                          style={{fontSize: 20}}
                          primaryText={moment(feriado.get('fecha')).format('DD/MM/YY')}
                        />
                        <MaterialUI.Divider />
                      </div>
                        )}
                  </MaterialUI.List>
                </Col>
              </Row>
            </MaterialUI.Paper>
          </Col>
        </Row>
        {checkPermissions(['admin', 'administrador_feriados']) &&
          <MaterialUI.FloatingActionButton
            className="bottonFlotanteAdd"
            onTouchTap={this.addFeriado}
          >
            <FontAwesome name="plus" />
          </MaterialUI.FloatingActionButton>}
        <EliminarConfirmacionC
          eliminarId={eliminarId}
          confirmar={this.confirmDelete}
          cancelar={this.deleteFeriado}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/modules/feriados/component.js